import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Dropdown from './Dropdown';
import FaqData from './FaqData';
import LitStructuredText from './generic/LitStructuredText';

const ModularFaqs = (data) => {
  const faqDropdownData = query();
  const faqData = FaqData(faqDropdownData);
  const { filterBy, filterByArrayContent, heading, backgroundColour } =
    data.data;
  let filteredDataArray = [];
  let faqArray = [];
  faqData.forEach((object) => {
    object.dropdownQuestions.forEach((faqObj) => {
      if (filterBy) {
        if (
          faqObj?.answer.includes(filterBy) ||
          faqObj?.question.includes(filterBy)
        ) {
          filteredDataArray.push({
            question: faqObj.question,
            answer: faqObj.answer,
          });
        }
      } else {
        filterByArrayContent.forEach(({ string }, index) => {
          if (
            faqObj?.answer.includes(string) ||
            faqObj?.question.includes(string)
          ) {
            filteredDataArray.push({
              question: faqObj.question,
              answer: faqObj.answer,
              index: index,
            });
          }
        });
        filteredDataArray.sort((a, b) => a.index - b.index);
      }
    });
  });
  faqArray.push({
    dropdownQuestions: filteredDataArray,
  });

  return (
    <div
      className={`Black modular-faq-container modular-heading-secondary modular-text-center`}
    >
      {heading && <LitStructuredText data={heading} basic />}
      <div className="modular-global-width">
        {faqArray?.map(({ dropdownQuestions }, index) => {
          return (
            <Dropdown
              dropdownTitles={dropdownQuestions}
              index={index}
              forceDropdown={true}
              isModular={true}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ModularFaqs;
const query = () =>
  useStaticQuery(graphql`
    query {
      allFaqs {
        nodes {
          answer
          question
          category
        }
      }
    }
  `);
export const fragment = graphql`
  fragment ModularFaqs on DatoCmsModularFaq {
    internal {
      type
    }
    id
    backgroundColour
    heading {
      value
    }
    filterBy
    filterByArrayContent {
      string
    }
  }
`;
